export default __webpack_public_path__ + "img/BF.a98c5b9a03b5468fdeed72be8aef8554.jpg";